import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";

const linkStyle = {
    color: 'inherit',
    textDecoration: 'none',
};

function MenuItem(props) {
  const { active = false, Icon, to, label, small = false } = props;

  return (
    <Link to={to} style={linkStyle}>
        <ListItemButton
          sx={{
            alignItems: 'center',
            borderRadius: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            pl: '16px',
            pr: '16px',
            py: '0px',
            textAlign: 'left',
            width: '100%',
            height: 1,
            '&:hover': {
              backgroundColor: 'grey.100'
            }
          }}
        >
          {Icon && (
            <ListItemIcon
              sx={{
                alignItems: 'center',
                mr: -2,
                ...(active && {
                  color: 'primary.main'
                }),
              }}
            >
              <Icon />
            </ListItemIcon>
          )}
          <ListItemText
            disableTypography
            sx={{
              flexGrow: 1,
                color: 'grey.700',
                ...(active && {
                  color: 'primary.main',
                  fontWeight: 'medium'
                }),
                ...(small && {
                  color: 'grey.400',
                  typography: 'subtitle2',
              })
            }}
          >
            {label}
          </ListItemText>
        </ListItemButton>
    </Link>
  );
}

export default MenuItem
